import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const Contact = () => {
  let success = new URL(document.location.href).searchParams.get('success');
  return (
    <div className={s.contact}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Send os en besked</h1>
        {success === 'true' ? <p className={s.success}>Beskeden blev sendt.</p> :
          <form method="post" encType="text/plain" action="/api/credits/sendFeedback">
            <p className={s.text}>
              <div><b>Fulde navn</b></div>
              <div><input type="text" required name="name"/></div>
            </p>
            <p className={s.text}>
              <div><b>Email adresse</b></div>
              <div><input type="email" required name="email"/></div>
            </p>
            <p className={s.text}>
              <div><b>Din besked</b></div>
              <div><textarea required name="text" cols="30" rows="10"/></div>
            </p>
            <button type="submit">Send besked</button>
          </form>
        }
      </Wrapper>
    </div>
  );
};

export default Contact;
